<div #login_modal class="email-sent-container">
    <div class="email-sent-wrapper">
        <div class="detail-wrapper">
            <p>{{translatorSvc.getLabel('registerEmailSent')}}</p>
            <button class="modal-text-button" (click)="onClose()">{{translatorSvc.getLabel('close')}}</button>
        </div>
    </div>
</div>
